// TODO: currently redefine solana method types in ws embed to avoid metaplex umi dependency from solana-controllers
// remove this and import form solana-controllers once metaplex is removed
const SOLANA_METHOD_TYPES = {
  GET_ACCOUNTS: "getAccounts",
  SOLANA_REQUEST_ACCOUNTS: "solana_requestAccounts",
  SEND_TRANSACTION: "solana_sendTransaction",
  SIGN_TRANSACTION: "solana_signTransaction",
  SIGN_ALL_TRANSACTIONS: "solana_signAllTransactions",
  SIGN_MESSAGE: "solana_signMessage",
  SOLANA_PRIVATE_KEY: "solana_privateKey",
  PRIVATE_KEY: "private_key",
  SOLANA_PUBLIC_KEY: "solana_publicKey",
  PUBLIC_KEY: "public_key"
};
const SOLANA_CHAIN_IDS = {
  SOLANA_MAINNET: "0x65",
  SOLANA_TESTNET: "0x66",
  SOLANA_DEVNET: "0x67"
};
const EVM_METHOD_TYPES = {
  GET_ACCOUNTS: "eth_accounts",
  ETH_TRANSACTION: "eth_sendTransaction",
  ETH_ESTIMATE_AA_TRANSACTION_GAS: "eth_estimateAATransactionGas",
  ETH_REQUEST_ACCOUNTS: "eth_requestAccounts",
  ETH_SEND_RAW_TRANSACTION: "eth_sendRawTransaction",
  ETH_SIGN: "eth_sign",
  ETH_SIGN_TYPED_DATA_V4: "eth_signTypedData_v4",
  PERSONAL_SIGN: "personal_sign",
  ETH_GET_TRANSACTION_COUNT: "eth_getTransactionCount",
  ETH_GET_TRANSACTION_BY_HASH: "eth_getTransactionByHash",
  ETH_GET_TRANSACTION_RECEIPT: "eth_getTransactionReceipt",
  WATCH_ASSET: "wallet_watchAsset",
  ETH_GET_BLOCK_BY_HASH: "eth_getBlockByHash",
  ETH_GET_CODE: "eth_getCode",
  ETH_GET_GAS_PRICE: "eth_gasPrice",
  ETH_PRIVATE_KEY: "eth_privateKey",
  PRIVATE_KEY: "private_key",
  ETH_PUBLIC_KEY: "eth_publicKey",
  PUBLIC_KEY: "public_key",
  SWITCH_CHAIN: "wallet_switchEthereumChain",
  ADD_CHAIN: "wallet_addEthereumChain"
};

export { EVM_METHOD_TYPES, SOLANA_CHAIN_IDS, SOLANA_METHOD_TYPES };
